import React__default from 'react';
import { FlexBox } from '../shared/components/FlexBox.mjs';

const InstructionSet = ({ children })=>/*#__PURE__*/ React__default.createElement(FlexBox, {
        flexDirection: "column",
        gap: 2
    }, children);

export { InstructionSet };
//# sourceMappingURL=InstructionSet.mjs.map
